/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/checkServer": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["checkServer"];
        put?: never;
        post: operations["checkServer_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/recommand/v2/dps/batch_item": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 批量调用根据用户推荐游戏
         * @description 批量获取用户游戏推荐
         */
        post: operations["getBatchItemLocalRecommendation_2"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/recommand/v2/batch_item_local": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 批量调用根据用户推荐游戏
         * @description 批量获取用户游戏推荐
         */
        post: operations["getBatchItemLocalRecommendation_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/recommand/rec/tag_provider": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 标签Provider推荐
         * @description 根据标签和Provider提供推荐
         */
        post: operations["getTagProviderRecommend"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/recommand/rec/relevant": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 相关推荐
         * @description 根据指定物品提供相关推荐
         */
        post: operations["getRelevantRecommend"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/recommand/rec/provider": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Provider推荐
         * @description 根据指定Provider提供推荐
         */
        post: operations["getProviderRecommend"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/recommand/rec/personal": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 个性化推荐
         * @description 根据用户行为和偏好提供个性化推荐
         */
        post: operations["getPersonalRecommend"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/recommand/rec/ordered_provider": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 有序Provider推荐
         * @description 根据指定Provider提供有序推荐
         */
        post: operations["getOrderedProviderRecommend"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/recommand/rec/ordered_items": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 有序物品推荐
         * @description 提供有序物品推荐
         */
        post: operations["getOrderedItemsRecommend"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/recommand/rec/new_game": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 新游戏推荐
         * @description 提供新游戏推荐
         */
        post: operations["getNewGameRecommend"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/recommand/rec/lottery_personal": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 彩票个性化推荐
         * @description 根据用户偏好提供彩票个性化推荐
         */
        post: operations["getLotteryPersonalRecommend"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/recommand/rec/hot_provider": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 热门Provider推荐
         * @description 提供热门Provider推荐
         */
        post: operations["getHotProviderRecommend"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/recommand/rec/explore": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 探索推荐
         * @description 提供探索类推荐
         */
        post: operations["getExploreRecommend"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/recommand/rec/crypto": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 加密货币推荐
         * @description 提供加密货币相关推荐
         */
        post: operations["getCryptoRecommend"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/recommand/rec/casino": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 娱乐场推荐
         * @description 提供娱乐场游戏推荐
         */
        post: operations["getCasinoRecommend"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/recommand/v2/dps/tag": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 推荐Tag
         * @description 推荐游戏标签
         */
        post: operations["getTagRecommendation"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/recommand/v2/tag": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 推荐Tag
         * @description 推荐游戏标签
         */
        post: operations["getTagRecommendation_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/recommand/v2/dps/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 搜索游戏
         * @description 搜索游戏
         */
        post: operations["getSearchItemRecommendation"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/recommand/v2/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 搜索游戏
         * @description 搜索游戏
         */
        post: operations["getSearchItemRecommendation_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/recommand/v2/relevant_game": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 根据游戏推荐相似游戏
         * @description 根据指定游戏推荐相似游戏
         */
        post: operations["getRelevantGameRecommendation"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/recommand/v2/dps/relevant_game": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 根据游戏推荐相似游戏
         * @description 根据指定游戏推荐相似游戏
         */
        post: operations["getRelevantGameRecommendation_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/recommand/v2/provider": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 推荐Provider
         * @description 推荐游戏厂商
         */
        post: operations["getProviderRecommendation"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/recommand/v2/dps/provider": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 推荐Provider
         * @description 推荐游戏厂商
         */
        post: operations["getProviderRecommendation_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/recommand/v2/new_games": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 新游戏推荐
         * @description 推荐最新上线的游戏
         */
        post: operations["getNewGamesRecommendation"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/recommand/v2/dps/new_games": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 新游戏推荐
         * @description 推荐最新上线的游戏
         */
        post: operations["getNewGamesRecommendation_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/recommand/v2/item": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 根据用户推荐游戏
         * @description 根据用户偏好推荐游戏
         */
        post: operations["getItemRecommendation"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/recommand/v2/dps/item": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 根据用户推荐游戏
         * @description 根据用户偏好推荐游戏
         */
        post: operations["getItemRecommendation_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/recommand/v2/continue_game": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 推荐最近玩的游戏
         * @description 推荐最近玩的游戏
         */
        post: operations["getContinueGameRecommendation"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/recommand/v2/dps/continue_game": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 推荐最近玩的游戏
         * @description 推荐最近玩的游戏
         */
        post: operations["getContinueGameRecommendation_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/recommand/v2/batch_item": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 批量调用根据用户推荐游戏
         * @description 批量获取用户游戏推荐
         */
        post: operations["getBatchItemRecommendation"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/recommand/dps/util/getRedis": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["getRedis"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/recommand/dps/util/deleteRedis": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["deleteRedis"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/recommand/dps/util/csvUpload": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["uploadCsv"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/recommand/dps/game/recommend": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 根据用户推荐游戏
         * @description 根据用户偏好推荐游戏
         */
        post: operations["getItemRecommendation_2"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/recommand/dps/game/cache/recommend": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 根据用户推荐游戏
         * @description 根据用户偏好推荐游戏
         */
        post: operations["getGameCache"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/recommand/sportData/sport/recommend": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取类目
         * @description 获取类目
         */
        get: operations["getSecond"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/recommand/sport/vaix/topMatches": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 顶级活动
         * @description 顶级活动
         */
        get: operations["getTopMatches"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/recommand/sport/vaix/sports": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 运动类型
         * @description 运动类型
         */
        get: operations["getSports"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/recommand/sport/vaix/hotMatches": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 热门比赛
         * @description 热门比赛
         */
        get: operations["getHotMatches"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/recommand/sport/vaix/hotCombosMatches": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * hotCombosMatches
         * @description hotCombosMatches
         */
        get: operations["getHotCombosMatches"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/recommand/sport/vaix/customBetMatches": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * customBetMatches
         * @description customBetMatches
         */
        get: operations["getCustomBetMatches"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/recommand/sport/vaix/bettingMatches": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * bettingMatches
         * @description bettingMatches
         */
        get: operations["getBettingMatches"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/sport/recommand/sport/v2/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 体育搜索推荐
         * @description 体育搜索推荐，显示类目以及赛事等信息
         */
        get: operations["getRecommandSportSearch"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/sport/recommand/sport/v2/search/sport": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 搜索推荐-运动类型
         * @description 搜索推荐-运动类型
         */
        get: operations["getSportSearchSport"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/sport/recommand/sport/v2/search/league": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 搜索推荐-联赛
         * @description 搜索推荐-联赛
         */
        get: operations["getSportSearchLeague"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        Health: {
            details: {
                [key: string]: Record<string, never>;
            };
        };
        /** @description 批量调用根据用户推荐游戏请求 */
        BatchItemRecommandRequest: {
            /**
             * Format: int32
             * @description 设备类型：1=手机，2=桌面
             * @example 1
             */
            device: number;
            /** @description 玩家渠道 */
            channel: string;
            /** @description kyc国家 */
            kyc_country: string;
            /** @description 用户语言 */
            bc_lang: string;
            /** @description 用户语言国家 */
            bc_lang_country: string;
            /** @description 浏览器语言 */
            browser_lang: string;
            /** @description 是否只返回手机端 */
            mobile_optimized_only_list: boolean[];
            /** @description 区域封禁码 */
            area_code: string;
            /** @description 返回条数列表 */
            limit_list: number[];
            /** @description 分页偏移量列表 */
            offset_list: number[];
            /** @description 游戏标签列表 */
            tag_list: string[][];
            /** @description 币种字段列表 */
            site_referral_currency: string[];
            /** @description 指定分类筛选列表 */
            category_list: number[][];
            /** @description 指定厂商列表 */
            provider_list: string[][];
            /** @description 字段查询列表 */
            field_config_list: components["schemas"]["FieldConfigRequest"][][];
            /** @description 该栏位个性化配置；1:个性化，2:global(全站热度),3:local(本地化热度)，默认1：个性化 */
            personal_list: string[];
            /** @description 该栏位是否允许重复；false:不允许重复，true:允许重复，默认false */
            repeat_list: boolean[];
            user_id: string;
        };
        /** @description 游戏查询请求参数字段公共 */
        FieldConfigRequest: {
            /** @description 字段名 */
            field_name: string;
            /** @description 查询值列表 */
            field_value: string[];
            /**
             * @description 查询类型
             * @enum {string}
             */
            query_type: "IN" | "NOT_IN";
        };
        /** @description dps推荐返回结构 */
        DpsGameResultListListRecommendItemData: {
            /**
             * Format: int32
             * @description 响应状态码
             * @example 200
             */
            code: number;
            /**
             * @description 响应消息
             * @example 成功
             */
            msg: string;
            /** @description 国家 */
            country: string;
            data: components["schemas"]["RecommendItemData"][][];
            /**
             * @description 请求唯一标识
             * @example log123
             */
            log_id: string;
            /**
             * @description 是否为降级响应
             * @example false
             */
            is_fallback: boolean;
            /**
             * @description 最大数量
             * @example 10
             */
            max_num: string;
            /**
             * @description 最大数量列表
             * @example [
             *       5,
             *       8,
             *       12
             *     ]
             */
            max_num_list: string[];
        };
        /** @description 推荐物品数据 */
        RecommendItemData: Record<string, never>;
        /** @description 标签Provider推荐请求参数 */
        TagProviderRequest: {
            sectionList?: string;
            /** @description kyc国家 */
            kyc_country?: string;
            /** @description 用户语言 */
            bc_lang?: string;
            /** @description 用户语言国家 */
            bc_lang_country?: string;
            /** @description 浏览器语言 */
            browser_lang?: string;
            /**
             * @description 栏位标识
             * @example tag_provider
             */
            section_id: string;
            /**
             * @description 实验分流标识
             * @example exp123
             */
            exp_id?: string;
            user_id?: string;
        };
        /** @description 基础推荐响应 */
        SingleRecommandResponse: {
            /**
             * Format: int32
             * @description 响应状态码
             * @example 200
             */
            code: number;
            /**
             * @description 响应消息
             * @example 成功
             */
            msg: string;
            /**
             * @description 分页起点
             * @example 0
             */
            offset: string;
            /** @description 推荐数据列表 */
            data: components["schemas"]["RecommendItemData"][];
            /**
             * @description 请求唯一标识
             * @example log123
             */
            log_id: string;
            /**
             * @description 是否为降级响应
             * @example false
             */
            is_fallback: boolean;
            /**
             * @description 实验分流标识
             * @example exp123
             */
            exp_id: string;
            /**
             * @description 策略ID
             * @example strategy123
             */
            strategy_id: string;
            /**
             * @description 栏位标识
             * @example casino_hot
             */
            section_id: string;
            /**
             * @description 最大数量
             * @example 10
             */
            max_num: string;
        };
        /** @description 相关推荐请求参数 */
        RelevantRecommandRequest: {
            /**
             * @description 是否需要置顶数据
             * @example false
             */
            needTopItem?: string;
            /**
             * @description 设备类型（1=手机/2=桌面）
             * @example 1
             */
            device?: string;
            /**
             * @description 玩家站点
             * @example bc
             */
            channel?: string;
            sectionList?: string;
            /** @description kyc国家 */
            kyc_country?: string;
            /** @description 用户语言 */
            bc_lang?: string;
            /** @description 用户语言国家 */
            bc_lang_country?: string;
            /** @description 浏览器语言 */
            browser_lang?: string;
            /**
             * @description 栏位标识
             * @example game_related
             */
            section_id: string;
            /**
             * @description 物品ID
             * @example game123
             */
            item_id: string;
            /**
             * @description 物品类型
             * @example game
             */
            item_type: string;
            /**
             * @description 实验分流标识
             * @example exp123
             */
            exp_id?: string;
            user_id?: string;
        };
        /** @description Provider推荐请求参数 */
        ProviderRecommandRequest: {
            /**
             * @description Provider名称
             * @example pragmatic
             */
            provider: string;
            /**
             * @description 设备类型（1=手机/2=桌面）
             * @example 1
             */
            device?: string;
            /**
             * @description 玩家站点
             * @example bc
             */
            channel?: string;
            sectionList?: string;
            /** @description kyc国家 */
            kyc_country?: string;
            /** @description 用户语言 */
            bc_lang?: string;
            /** @description 用户语言国家 */
            bc_lang_country?: string;
            /** @description 浏览器语言 */
            browser_lang?: string;
            /**
             * @description 栏位标识
             * @example casino_provider
             */
            section_id: string;
            /**
             * @description 实验分流标识
             * @example exp123
             */
            exp_id?: string;
            /**
             * @description 是否需要置顶数据
             * @example false
             */
            need_top_item?: string;
            user_id?: string;
        };
        /** @description 个性化推荐请求参数 */
        PersonalRecommandRequest: {
            /**
             * @description 设备类型（1=手机/2=桌面）
             * @example 1
             */
            device?: string;
            /**
             * @description 游戏标签（仅casino_tag栏位必填）
             * @example slots
             */
            tag?: string;
            /**
             * @description Provider筛选
             * @example pragmatic
             */
            provider?: string;
            /**
             * @description 玩家站点
             * @example bc
             */
            channel?: string;
            sectionList?: string;
            /** @description kyc国家 */
            kyc_country?: string;
            /**
             * @description 用户站内语言
             * @example zh
             */
            bc_lang?: string;
            /** @description 用户语言国家 */
            bc_lang_country?: string;
            /**
             * @description 浏览器语言
             * @example zh-CN
             */
            browser_lang?: string;
            /**
             * @description 栏位标识
             * @example casino_picks_for_you
             */
            section_id: string;
            /**
             * @description 实验分流标识
             * @example exp123
             */
            exp_id?: string;
            /**
             * @description 是否需要置顶数据
             * @example false
             */
            need_top_item?: string;
            /**
             * @description 区域限制
             * @example US
             */
            area_code?: string;
            user_id?: string;
        };
        /** @description 有序Provider推荐请求参数 */
        OrderedProviderRequest: {
            /**
             * @description Provider名称
             * @example pragmatic
             */
            provider: string;
            sectionList?: string;
            /** @description kyc国家 */
            kyc_country?: string;
            /** @description 用户语言 */
            bc_lang?: string;
            /** @description 用户语言国家 */
            bc_lang_country?: string;
            /** @description 浏览器语言 */
            browser_lang?: string;
            /**
             * @description 栏位标识
             * @example casino_provider_ordered
             */
            section_id: string;
            /**
             * @description 实验分流标识
             * @example exp123
             */
            exp_id?: string;
            user_id?: string;
        };
        /** @description 有序物品推荐请求参数 */
        OrderedItemsRequest: {
            /**
             * @description 设备类型（1=手机/2=桌面）
             * @example 1
             */
            device?: string;
            /** @description provider限制 */
            provider?: string;
            /**
             * @description 玩家站点
             * @example bc
             */
            channel?: string;
            sectionList?: string;
            /** @description kyc国家 */
            kyc_country?: string;
            /**
             * @description 用户所属国家
             * @example CN
             */
            country?: string;
            /** @description 用户语言 */
            bc_lang?: string;
            /** @description 用户语言国家 */
            bc_lang_country?: string;
            /** @description 浏览器语言 */
            browser_lang?: string;
            /**
             * @description 栏位标识
             * @example casino_ordered
             */
            section_id: string;
            /**
             * @description 实验分流标识
             * @example exp123
             */
            exp_id?: string;
            /**
             * @description 是否需要置顶数据
             * @example false
             */
            need_top_item?: string;
            /** @description 推荐物品规则所参考的栏位标识 */
            target_section_id?: string;
            /** @description 排序依据字段名 */
            order_by?: string;
            /** @description 排序顺序 */
            order?: string;
            /**
             * @description 区域限制
             * @example US
             */
            area_code?: string;
            user_id?: string;
        };
        /** @description 新游戏推荐请求参数 */
        NewGameRecommandRequest: {
            /**
             * @description 设备类型（1=手机/2=桌面）
             * @example 1
             */
            device?: string;
            /**
             * @description 玩家站点
             * @example bc
             */
            channel?: string;
            sectionList?: string;
            /** @description kyc国家 */
            kyc_country?: string;
            /**
             * @description 用户所属国家
             * @example CN
             */
            country?: string;
            /** @description 用户语言 */
            bc_lang?: string;
            /** @description 用户语言国家 */
            bc_lang_country?: string;
            /** @description 浏览器语言 */
            browser_lang?: string;
            /**
             * @description 栏位标识
             * @example casino_new
             */
            section_id: string;
            /**
             * @description 实验分流标识
             * @example exp123
             */
            exp_id?: string;
            /**
             * @description 是否需要置顶数据
             * @example false
             */
            need_top_item?: string;
            /**
             * @description 区域限制
             * @example US
             */
            area_code?: string;
            /**
             * @description provider限制
             * @example Evoplay,Blueprin
             */
            provider?: string;
            /** @description 游戏标签 */
            tag?: string;
            user_id?: string;
        };
        /** @description 彩票个性化推荐请求参数 */
        LotteryPersonalRequest: {
            sectionList?: string;
            /** @description kyc国家 */
            kyc_country?: string;
            /**
             * @description 用户所属国家
             * @example CN
             */
            country?: string;
            /**
             * @description 用户站内语言
             * @example zh
             */
            bc_lang?: string;
            /** @description 用户语言国家 */
            bc_lang_country?: string;
            /**
             * @description 浏览器语言
             * @example zh-CN
             */
            browser_lang?: string;
            /**
             * @description 栏位标识
             * @example lottery_picks_for_you
             */
            section_id: string;
            /**
             * @description 实验分流标识
             * @example exp123
             */
            exp_id?: string;
            /**
             * @description 是否需要置顶数据
             * @example false
             */
            need_top_item?: string;
            user_id?: string;
        };
        /** @description 热门Provider推荐请求参数 */
        HotProviderRequest: {
            /**
             * @description 设备类型（1=手机/2=桌面）
             * @example 1
             */
            device?: string;
            sectionList?: string;
            /** @description kyc国家 */
            kyc_country?: string;
            /** @description 用户语言 */
            bc_lang?: string;
            /** @description 用户语言国家 */
            bc_lang_country?: string;
            /** @description 浏览器语言 */
            browser_lang?: string;
            /**
             * @description 栏位标识
             * @example casino_hot_provider
             */
            section_id: string;
            /**
             * @description 实验分流标识
             * @example exp123
             */
            exp_id?: string;
            /**
             * @description 是否需要置顶数据
             * @example false
             */
            need_top_item?: string;
            user_id?: string;
        };
        /** @description 探索推荐请求参数 */
        ExploreRecommandRequest: {
            /** @description provider限制 */
            provider?: string;
            /**
             * @description 设备类型（1=手机/2=桌面）
             * @example 1
             */
            device?: string;
            /**
             * @description 玩家站点
             * @example bc
             */
            channel?: string;
            sectionList?: string;
            /** @description kyc国家 */
            kyc_country?: string;
            /**
             * @description 用户所属国家
             * @example CN
             */
            country?: string;
            /** @description 用户语言 */
            bc_lang?: string;
            /** @description 用户语言国家 */
            bc_lang_country?: string;
            /** @description 浏览器语言 */
            browser_lang?: string;
            /**
             * @description 栏位标识
             * @example casino_explore
             */
            section_id: string;
            /**
             * @description 实验分流标识
             * @example exp123
             */
            exp_id?: string;
            /**
             * @description 是否需要置顶数据
             * @example false
             */
            need_top_item?: string;
            /**
             * @description 区域限制
             * @example US
             */
            area_code?: string;
            user_id?: string;
        };
        /** @description 加密货币推荐请求参数 */
        CryptoRecommandRequest: {
            sectionList?: string;
            /** @description kyc国家 */
            kyc_country?: string;
            /**
             * @description 用户所属国家
             * @example CN
             */
            country?: string;
            /** @description 用户语言 */
            bc_lang?: string;
            /** @description 用户语言国家 */
            bc_lang_country?: string;
            /** @description 浏览器语言 */
            browser_lang?: string;
            /**
             * @description 栏位标识
             * @example crypto_hot
             */
            section_id: string;
            /**
             * @description 实验分流标识
             * @example exp123
             */
            exp_id?: string;
            /**
             * @description 是否需要置顶数据
             * @example false
             */
            need_top_item?: string;
            user_id?: string;
        };
        /** @description 娱乐场推荐请求参数 */
        CasinoRecommandRequest: {
            /**
             * @description 玩家站点
             * @example bc
             */
            channel?: string;
            /**
             * @description 设备类型（1=手机/2=桌面）
             * @example 1
             */
            device?: string;
            sectionId?: string;
            sectionList?: string;
            /** @description kyc国家 */
            kyc_country?: string;
            /**
             * @description 用户所属国家
             * @example CN
             */
            country?: string;
            /**
             * @description 用户站内语言
             * @example zh
             */
            bc_lang?: string;
            /** @description 用户语言国家 */
            bc_lang_country?: string;
            /**
             * @description 浏览器语言
             * @example zh-CN
             */
            browser_lang?: string;
            /**
             * @description 栏位标识
             * @example casino_hot
             */
            section_id_list: string;
            /**
             * @description 实验分流标识
             * @example exp123
             */
            exp_id?: string;
            /** @description 游戏标签的列表 */
            tag_list?: string;
            /** @description 不同栏位所需请求结果个数的列表 */
            limit_list?: string;
            /**
             * @description 是否需要置顶数据
             * @example false
             */
            need_top_item?: string;
            /** @description 请求结果起点列表 */
            offset_list?: string;
            /**
             * @description 区域限制
             * @example US
             */
            area_code?: string;
            user_id?: string;
        };
        /** @description 基础推荐响应 */
        MultipleBaseRecommandResponse: {
            /**
             * Format: int32
             * @description 响应状态码
             * @example 200
             */
            code: number;
            /**
             * @description 响应消息
             * @example 成功
             */
            msg: string;
            /** @description 推荐数据列表 */
            data: components["schemas"]["RecommendItemData"][][];
            /**
             * @description 请求唯一标识
             * @example log123
             */
            log_id: string;
            /**
             * @description 是否为降级响应
             * @example false
             */
            is_fallback: boolean;
            /**
             * @description 实验分流标识
             * @example exp123
             */
            exp_id: string;
            /** @description 每个栏位策略实验分流标识列表 */
            strategy_id_list: string;
            /** @description 每个栏位的栏位标识 */
            section_id_list: string;
            /** @description 每个栏位最大可返回推荐物品数列表 */
            offset_list: string;
            /** @description 每个栏位最大可返回推荐物品数列表 */
            max_num_list: string;
        };
        /** @description 推荐Tag请求 */
        TagRecommandRequest: {
            /**
             * Format: int32
             * @description 设备类型：1=手机，2=桌面，3=通用
             * @example 1
             */
            device: number;
            /** @description kyc国家 */
            kyc_country: string;
            /** @description 用户语言 */
            bc_lang: string;
            /** @description 用户语言国家 */
            bc_lang_country: string;
            /** @description 浏览器语言 */
            browser_lang: string;
            /** @description 币种字段列表 */
            site_referral_currency: string[];
            /** @description 字段查询列表 */
            field_config: components["schemas"]["FieldConfigRequest"][];
            user_id: string;
        };
        /** @description dps推荐返回结构 */
        DpsGameResultListRecommendItemData: {
            /**
             * Format: int32
             * @description 响应状态码
             * @example 200
             */
            code: number;
            /**
             * @description 响应消息
             * @example 成功
             */
            msg: string;
            /** @description 国家 */
            country: string;
            data: components["schemas"]["RecommendItemData"][];
            /**
             * @description 请求唯一标识
             * @example log123
             */
            log_id: string;
            /**
             * @description 是否为降级响应
             * @example false
             */
            is_fallback: boolean;
            /**
             * @description 最大数量
             * @example 10
             */
            max_num: string;
            /**
             * @description 最大数量列表
             * @example [
             *       5,
             *       8,
             *       12
             *     ]
             */
            max_num_list: string[];
        };
        /** @description 搜索游戏请求 */
        SearchRecommandRequest: {
            /**
             * Format: int32
             * @description 设备类型：1=手机，2=桌面，3=通用
             * @example 1
             */
            device: number;
            /** @description 游戏标签列表，支持多个标签筛选 */
            tag: string[];
            /** @description 游戏分类ID列表：1=Slots，4=Live Casino，支持多个分类筛选 */
            category: number[];
            /** @description 指定厂商名称列表，支持多个厂商筛选 */
            provider: string[];
            /** @description 玩家渠道 */
            channel: string;
            /** @description kyc国家 */
            kyc_country: string;
            /** @description 用户语言 */
            bc_lang: string;
            /** @description 用户语言国家 */
            bc_lang_country: string;
            /** @description 浏览器语言 */
            browser_lang: string;
            /** @description 币种字段列表 */
            site_referral_currency: string[];
            /** @description 是否只返回手机端 */
            mobile_optimized_only: boolean;
            /** @description 区域封禁码，仅用于排除区域受限的游戏 */
            area_code: string;
            /** @description 搜索关键字 */
            search_word: string;
            /** @description 字段查询列表 */
            field_config: components["schemas"]["FieldConfigRequest"][];
            user_id: string;
        };
        /** @description 根据游戏推荐相似游戏请求 */
        RelevantGameRecommandRequest: {
            /**
             * Format: int32
             * @description 设备类型：1=手机，2=桌面，3=通用
             * @example 1
             */
            device: number;
            /** @description 游戏标签列表，支持多个标签筛选 */
            tag: string[];
            /** @description 游戏分类ID列表：1=Slots，4=Live Casino，支持多个分类筛选 */
            category: number[];
            /** @description 指定厂商名称列表，支持多个厂商筛选 */
            provider: string[];
            /** @description 玩家渠道 */
            channel: string;
            /** @description kyc国家 */
            kyc_country: string;
            /** @description 用户语言 */
            bc_lang: string;
            /** @description 用户语言国家 */
            bc_lang_country: string;
            /** @description 浏览器语言 */
            browser_lang: string;
            /** @description 币种字段列表 */
            site_referral_currency: string[];
            /** @description 是否只返回手机端 */
            mobile_optimized_only: boolean;
            /** @description 区域封禁码，仅用于排除区域受限的游戏 */
            area_code: string;
            /** @description 目标游戏ID，用于推荐相似游戏 */
            game_id: string;
            /** @description 字段查询列表 */
            field_config: components["schemas"]["FieldConfigRequest"][];
            user_id: string;
        };
        /** @description 新游戏推荐请求 */
        NewGamesRecommandRequest: {
            /**
             * Format: int32
             * @description 设备类型：1=手机，2=桌面，3=通用
             * @example 1
             */
            device: number;
            /** @description 游戏标签列表，支持多个标签筛选 */
            tag: string[];
            /** @description 游戏分类ID列表：1=Slots，4=Live Casino，支持多个分类筛选 */
            category: number[];
            /** @description 指定厂商名称列表，支持多个厂商筛选 */
            provider: string[];
            /** @description 玩家渠道 */
            channel: string;
            /** @description kyc国家 */
            kyc_country: string;
            /** @description 用户语言 */
            bc_lang: string;
            /** @description 用户语言国家 */
            bc_lang_country: string;
            /** @description 浏览器语言 */
            browser_lang: string;
            /** @description 是否只返回手机端 */
            mobile_optimized_only: boolean;
            /** @description 币种字段列表 */
            site_referral_currency: string[];
            /** @description 区域封禁码，仅用于排除区域受限的游戏 */
            area_code: string;
            /** @description 字段查询列表 */
            field_config: components["schemas"]["FieldConfigRequest"][];
            user_id: string;
        };
        /** @description 根据用户推荐游戏请求 */
        ItemRecommandRequest: {
            /**
             * Format: int32
             * @description 设备类型：1=手机，2=桌面，3=通用
             * @example 1
             */
            device: number;
            /** @description 游戏标签列表，支持多个标签筛选 */
            tag: string[];
            /** @description 游戏分类ID列表：1=Slots，4=Live Casino，支持多个分类筛选 */
            category: number[];
            /** @description 指定厂商名称列表，支持多个厂商筛选 */
            provider: string[];
            /** @description 玩家渠道 */
            channel: string;
            /** @description kyc国家 */
            kyc_country: string;
            /** @description 用户语言 */
            bc_lang: string;
            /** @description 用户语言国家 */
            bc_lang_country: string;
            /** @description 浏览器语言 */
            browser_lang: string;
            /** @description 是否只返回手机端 */
            mobile_optimized_only: boolean;
            /** @description 币种字段列表 */
            site_referral_currency: string[];
            /** @description 区域封禁码，仅用于排除区域受限的游戏 */
            area_code: string;
            /** @description 字段查询列表 */
            field_config: components["schemas"]["FieldConfigRequest"][];
            user_id: string;
        };
        /** @description dps推荐返回结构 */
        DpsGameResultListDpsMatchResponse: {
            /**
             * Format: int32
             * @description 响应状态码
             * @example 200
             */
            code: number;
            /**
             * @description 响应消息
             * @example 成功
             */
            msg: string;
            /** @description 国家 */
            country: string;
            data: components["schemas"]["DpsMatchResponse"][];
            /**
             * @description 请求唯一标识
             * @example log123
             */
            log_id: string;
            /**
             * @description 是否为降级响应
             * @example false
             */
            is_fallback: boolean;
            /**
             * @description 最大数量
             * @example 10
             */
            max_num: string;
            /**
             * @description 最大数量列表
             * @example [
             *       5,
             *       8,
             *       12
             *     ]
             */
            max_num_list: string[];
        };
        DpsMatchResponse: {
            /**
             * Format: int64
             * @description 体育运动ID
             */
            sportId: number;
            /** @description 体育运动名称 */
            sportName: string;
            /** @description 体育运动logo */
            sportLogoUrl: string;
            /**
             * Format: int64
             * @description 国家/地区ID
             */
            regionId: number;
            /** @description 国家/地区名称 */
            regionName: string;
            /** @description 国家/地区名称logo */
            regionLogoUrl: string;
            /**
             * Format: int64
             * @description 具体联赛ID
             */
            leagueId: number;
            /** @description 具体联赛名称 */
            leagueName: string;
            /** @description 具体联赛logo */
            leagueLogoUrl: string;
            /** @description 比赛阶段 */
            periods: string;
            /**
             * Format: int64
             * @description 比赛ID
             */
            id: number;
            /** @description 比赛名称 */
            name: string;
            /**
             * Format: int32
             * @description 比赛状态
             */
            matchStatus: number;
            /** @description 状态描述 */
            statusDesc: string;
            /** @description sportradar运动id */
            sportradarSportId: string;
            /** @description sportradar地区id */
            sportradarRegionId: string;
            /** @description sportradar联赛id */
            sportradarLeagueId: string;
            /** @description sportradar比赛id */
            sportradarMatchId: string;
            /**
             * Format: int64
             * @description 比赛开始时间（时间戳）
             */
            startTime: number;
            /**
             * Format: int64
             * @description 比赛结束时间（时间戳）
             */
            endTime: number;
            result: components["schemas"]["ResultResponse"];
            homeTeam: components["schemas"]["TeamResponse"];
            awayTeam: components["schemas"]["TeamResponse"];
            /** @description 赔率信息 */
            marketOdds: components["schemas"]["MarketOddsResponse"][];
            /** @description 赔率信息(新) */
            marketOddList: components["schemas"]["MarketEntity"][];
            /**
             * Format: int32
             * @description 赔率信息总数
             */
            totalMarkets: number;
            /** @description 直播状态 */
            liveStatusSet: components["schemas"]["LiveStatusSetResponse"][];
        };
        /** @description 直播状态 */
        LiveStatusSetResponse: {
            /** Format: int64 */
            id: number;
            /** Format: int64 */
            matchStatus: number;
            statusDesc: string;
            /** Format: int64 */
            periodTime: number;
        };
        /** @description 赔率信息(新) */
        MarketEntity: {
            /** @description 盘口id */
            marketId: string;
            /** @description 玩法名称 */
            marketName: string;
            /**
             * Format: int32
             * @description 玩法类型
             */
            marketTabType: number;
            /**
             * Format: int32
             * @description 状态 状态：1=active, -1=suspended, 0=deactivated, -2=handed_over, -3=settled, -4=cancelled 1为正常，其他的都置灰
             */
            status: number;
            /** @description 盘口投注项赔率列表 */
            outcomes: components["schemas"]["Outcomes"][];
        };
        /** @description 赔率信息 */
        MarketOddsResponse: {
            /**
             * Format: int64
             * @description 赔率ID
             */
            id: number;
            /**
             * Format: int64
             * @description 盘口来源博彩公司ID
             */
            bookmakerId: number;
            /** @description 赔率唯一code */
            code: string;
            /**
             * Format: int64
             * @description 队伍ID
             */
            teamId: number;
            /** @description 队伍名称 */
            teamName: string;
            /** @description 玩法唯一code */
            marketTypeCode: string;
            /**
             * Format: int32
             * @description 玩法类型
             */
            marketType: number;
            /**
             * Format: int32
             * @description 玩法子类型
             */
            marketSubType: number;
            /**
             * Format: int32
             * @description 时间类型：0 - 常规时间，1 - 前半场， 2 - 后半场， 3 - 加时赛， 4 - 点球大战
             */
            periodType: number;
            /** @description 详细规则 */
            rule: string;
            /** @description 详细描述 */
            desc: string;
            /** @description 盘口唯一代码 */
            oddsMarketCode: string;
            /**
             * Format: int64
             * @description 生效时间
             */
            marketEffectiveTime: number;
            /**
             * Format: int64
             * @description 过期时间
             */
            marketExpirationTime: number;
            /**
             * Format: int32
             * @description 盘口状态: 0-开盘 1-封盘 2-结算中 3-已结算
             */
            marketStatus: number;
            /** @description 赔率 */
            oddsValue: number;
            /** @description 前一个赔率 */
            preOddsValue: number;
            /** @description 初始赔率 */
            baseOddsValue: number;
            /**
             * Format: int32
             * @description 赔率状态
             */
            oddsStatus: number;
            /**
             * Format: int32
             * @description 0-赛前盘 1-滚球盘
             */
            oddsType: number;
            /**
             * Format: int64
             * @description 创建时间
             */
            createTime: number;
            /**
             * Format: int64
             * @description 更新时间
             */
            updateTime: number;
        };
        /** @description 盘口投注项赔率列表 */
        Outcomes: {
            /** @description 编码 */
            code: string;
            /** @description 投注项id */
            outcomeId: string;
            /** @description 投注项名称 */
            outcomeName: string;
            /** @description 当前赔率值 */
            odds: number;
            /**
             * Format: int32
             * @description 1=有效，0=无效
             */
            active: number;
            /**
             * Format: int64
             * @description 更新时间
             */
            updateTime: number;
            /**
             * Format: int32
             * @description 滚球盘类型 0=赛前盘 1=滚球盘
             */
            phase: number;
        };
        /** @description 比赛结果 */
        ResultResponse: {
            /** @description 主队得分 */
            home: string;
            /** @description 客队得分 */
            away: string;
            /** @description 比赛阶段 */
            period: string;
            /** @description 比赛结果 */
            winner: string;
        };
        /** @description 客队信息 */
        TeamResponse: {
            /**
             * Format: int64
             * @description 队伍id
             */
            teamId: number;
            /** @description 队伍名称 */
            teamName: string;
            /** @description 队伍logo */
            logoUrl: string;
            /**
             * Format: int32
             * @description 队伍得分
             */
            score: number;
        };
        /** @description dps推荐返回结构 */
        DpsResultListVaixTopMatchesResponse: {
            /** @description 是否成功 */
            success: boolean;
            /** @description 错误码 */
            errCode: string;
            /** @description 错误信息 */
            errMessage: string;
            /** @description 请求ID */
            requestId: string;
            /** @description 国家 */
            country: string;
            data: components["schemas"]["VaixTopMatchesResponse"][];
            /**
             * @description 最大数量
             * @example 10
             */
            max_num: string;
        };
        EventClockDto: {
            matchTime: string;
            stoppageTime: string;
            stoppageTimeAnnounced: string;
            remainingTime: string;
            remainingTimeInPeriod: string;
            stopped: boolean;
        };
        GroupConfigDTO: {
            key: string;
            /** Format: int32 */
            index: number;
            name: string;
        };
        /**
         * 按玩法类型分组的赔率
         * @description 从盘口服务获取的市场批量响应数据
         */
        MarketResponse: {
            /**
             * 盘口ID
             * @description 盘口ID
             */
            marketId: string;
            /**
             * 玩法类型
             * @description 玩法类型
             */
            marketName: string;
            marketTabType: string;
            colNameList: string[];
            /** Format: int32 */
            colSize: number;
            groupConfig: components["schemas"]["GroupConfigDTO"];
            options: components["schemas"]["OptionDTO"][];
            /**
             * 盘口投注项赔率列表
             * @description 盘口投注项赔率列表
             */
            marketSpecifierList: components["schemas"]["MarketSpecifierDTO"][];
        };
        /**
         * 盘口投注项赔率列表
         * @description 盘口投注项赔率列表
         */
        MarketSpecifierDTO: {
            specifiers: string;
            /** Format: int32 */
            status: number;
            outcomes: components["schemas"]["OutcomeDTO"][];
        };
        MatchPeriodScoreDto: {
            /** Format: int32 */
            matchStatusCode: number;
            /** Format: int32 */
            number: number;
            homeScore: number;
            awayScore: number;
        };
        OptionDTO: {
            groupName: string;
            name: string;
            type: string;
            content: Record<string, never>;
        };
        OutcomeDTO: {
            code: string;
            outcomeId: string;
            outcomeName: string;
            odds: number;
            /** Format: int32 */
            active: number;
            /** Format: int64 */
            updateTime: number;
            /** Format: int32 */
            phase: number;
            frontIndex: string;
        };
        /** @description 比赛阶段 */
        SportEventStatusDto: {
            clock: components["schemas"]["EventClockDto"];
            periodScores: components["schemas"]["MatchPeriodScoreDto"][];
            /** Format: int32 */
            status: number;
            statusName: string;
            /** Format: int32 */
            matchStatus: number;
            matchStatusName: string;
            homeScore: number;
            awayScore: number;
            /** Format: int32 */
            homePenaltyScore: number;
            /** Format: int32 */
            awayPenaltyScore: number;
            /** Format: int32 */
            homeGamescore: number;
            /** Format: int32 */
            awayGamescore: number;
            /** Format: int32 */
            homeLegscore: number;
            /** Format: int32 */
            awayLegscore: number;
            /** Format: int32 */
            currentServer: number;
            expediteMode: boolean;
            tiebreak: boolean;
            /** Format: int32 */
            homeSuspend: number;
            /** Format: int32 */
            awaySuspend: number;
            /** Format: int32 */
            balls: number;
            /** Format: int32 */
            strikes: number;
            /** Format: int32 */
            outs: number;
            bases: string;
            /** Format: int32 */
            homeBatter: number;
            /** Format: int32 */
            awayBatter: number;
            pitcher: string;
            batter: string;
            /** Format: int32 */
            pitchCount: number;
            /** Format: int32 */
            pitchesSeen: number;
            /** Format: int32 */
            totalHits: number;
            /** Format: int32 */
            totalPitches: number;
            /** Format: int32 */
            possession: number;
            /** Format: int32 */
            position: number;
            /** Format: int32 */
            get_try: number;
            /** Format: int32 */
            yards: number;
            /** Format: int32 */
            get_throw: number;
            /** Format: int32 */
            visit: number;
            /** Format: int32 */
            remainingReds: number;
            /** Format: int32 */
            delivery: number;
            /** Format: int32 */
            homeRemainingBowls: number;
            /** Format: int32 */
            awayRemainingBowls: number;
            /** Format: int32 */
            currentEnd: number;
            /** Format: int32 */
            innings: number;
            /** Format: int32 */
            over: number;
            /** Format: int32 */
            homePenaltyRuns: number;
            /** Format: int32 */
            awayPenaltyRuns: number;
            /** Format: int32 */
            homeDismissals: number;
            /** Format: int32 */
            awayDismissals: number;
            /** Format: int32 */
            currentCtTeam: number;
            /** Format: int32 */
            periodOfLeader: number;
            /** Format: int32 */
            homeDriveCount: number;
            /** Format: int32 */
            awayDriveCount: number;
            /** Format: int32 */
            homePlayCount: number;
            /** Format: int32 */
            awayPlayCount: number;
            /** Format: int32 */
            cricketHomeOver: number;
            /** Format: int32 */
            cricketHomeDelivery: number;
            /** Format: int32 */
            cricketAwayOver: number;
            /** Format: int32 */
            cricketAwayDelivery: number;
        };
        /** @description 体育ES数据 */
        VaixTopMatchesResponse: {
            /**
             * @description 体育项目ID
             * @example sr:sport:1
             */
            sportId: string;
            /**
             * @description 体育项目名称
             * @example Football
             */
            sportName: string;
            /**
             * @description 体育项目中文名称
             * @example 足球
             */
            sportNameZh: string;
            /**
             * @description 体育项目Logo URL
             * @example https://example.com/sport_logo.png
             */
            sportLogoUrl: string;
            /**
             * @description 赛事类别ID
             * @example sr:category:29
             */
            categoryId: string;
            /**
             * @description 赛事类别名称
             * @example England
             */
            categoryName: string;
            /**
             * @description 赛事类别中文名称
             * @example 英格兰
             */
            categoryNameZh: string;
            /**
             * @description 赛事类别国家代码
             * @example ENG
             */
            categoryCountryCode: string;
            /**
             * @description 赛事类别Logo URL
             * @example https://example.com/category_logo.png
             */
            categoryLogoUrl: string;
            /**
             * @description 联赛/锦标赛ID
             * @example sr:tournament:17
             */
            tournamentId: string;
            /**
             * @description 联赛/锦标赛名称
             * @example Premier League
             */
            tournamentName: string;
            /**
             * @description 联赛/锦标赛中文名称
             * @example 英超联赛
             */
            tournamentNameZh: string;
            /**
             * @description 联赛/锦标赛简称
             * @example 英超
             */
            tournamentShortName: string;
            /**
             * @description 联赛/锦标赛Logo URL
             * @example https://example.com/tournament_logo.png
             */
            tournamentLogoUrl: string;
            /**
             * Format: int32
             * @description 联赛/锦标赛级别
             * @example 1
             */
            tournamentLevel: number;
            /**
             * Format: int32
             * @description 联赛/锦标赛性别（0:男, 1:女, 2:未知）
             * @example 0
             */
            tournamentGender: number;
            /**
             * Format: int32
             * @description 联赛/锦标赛类型 (1:联赛, 2:杯赛)
             * @example 1
             */
            tournamentType: number;
            /**
             * Format: int32
             * @description 排序值
             * @example 10
             */
            tournamentSort: number;
            /**
             * @description 是否为国家比赛
             * @example true
             */
            isCountry: boolean;
            /**
             * @description 赛季ID
             * @example sr:season:93931
             */
            seasonId: string;
            /**
             * @description 赛季名称
             * @example Premier League 22/23
             */
            seasonName: string;
            /**
             * @description 赛季年份
             * @example 22/23
             */
            seasonYear: string;
            /**
             * @description 比赛ID或URN
             * @example sr:match:37939735
             */
            id: string;
            /**
             * @description 比赛名称
             * @example Arsenal vs Manchester United
             */
            name: string;
            /**
             * @description 主队ID
             * @example sr:competitor:42
             */
            homeId: string;
            /**
             * @description 主队名称
             * @example Arsenal
             */
            homeName: string;
            /**
             * @description 主队简称
             * @example ARS
             */
            homeShortName: string;
            /**
             * @description 主队Logo URL
             * @example https://example.com/arsenal_logo.png
             */
            homeLogoUrl: string;
            /** @description 主队球衣 */
            homeJersey: string;
            /**
             * @description 主队国家代码
             * @example ENG
             */
            homeCountryCode: string;
            /**
             * @description 客队ID
             * @example sr:competitor:35
             */
            awayId: string;
            /**
             * @description 客队名称
             * @example Manchester United
             */
            awayName: string;
            /**
             * @description 客队简称
             * @example MU
             */
            awayShortName: string;
            /**
             * @description 客队Logo URL
             * @example https://example.com/mu_logo.png
             */
            awayLogoUrl: string;
            /** @description 客队球衣 */
            awayJersey: string;
            /**
             * @description 客队国家代码
             * @example ENG
             */
            awayCountryCode: string;
            /**
             * @description 场馆ID
             * @example sr:venue:123
             */
            venueId: string;
            /**
             * @description 场馆名称
             * @example Emirates Stadium
             */
            venueName: string;
            /**
             * @description 裁判ID
             * @example sr:referee:456
             */
            refereeId: string;
            /**
             * @description 裁判名称
             * @example Anthony Taylor
             */
            refereeName: string;
            /**
             * @description 比赛类型
             * @example match
             */
            type: string;
            /**
             * @description 分组ID
             * @example sr:group:789
             */
            groupId: string;
            /**
             * @description 分组名称
             * @example Group A
             */
            groupName: string;
            /**
             * @description 阶段（例如：小组赛、淘汰赛）
             * @example Group Stage
             */
            phase: string;
            /**
             * @description 其他比赛ID
             * @example sr:match:99999
             */
            otherMatchId: string;
            /**
             * @description 联赛轮次
             * @example 21
             */
            tournamentRound: string;
            /**
             * Format: int64
             * @description 计划开始时间（Unix时间戳，毫秒）
             * @example 1674408600000
             */
            scheduledTime: number;
            /**
             * Format: int64
             * @description 计划结束时间（Unix时间戳，毫秒）
             * @example 1674415800000
             */
            scheduledEndTime: number;
            /**
             * Format: int32
             * @description 比赛状态
             */
            status: number;
            /** @description 比赛状态名称 */
            statusName: string;
            /**
             * Format: int32
             * @description 比赛状态
             */
            matchStatus: number;
            /** @description 比赛状态名称 */
            matchStatusName: string;
            sportEventStatus: components["schemas"]["SportEventStatusDto"];
            marketResponse: components["schemas"]["MarketResponse"];
            /**
             * @description 是否有雷达滚球赔率
             * @example true
             */
            hasRadarLiveOdds: boolean;
            /**
             * @description 是否有雷达赛前盘赔率
             * @example true
             */
            hasRadarPreMatchOdds: boolean;
        };
        /** @description dps推荐返回结构 */
        DpsResultListVaixSportsResponse: {
            /** @description 是否成功 */
            success: boolean;
            /** @description 错误码 */
            errCode: string;
            /** @description 错误信息 */
            errMessage: string;
            /** @description 请求ID */
            requestId: string;
            /** @description 国家 */
            country: string;
            data: components["schemas"]["VaixSportsResponse"][];
            /**
             * @description 最大数量
             * @example 10
             */
            max_num: string;
        };
        VaixSportsResponse: {
            /**
             * @description 体育项目ID
             * @example sr:sport:1
             */
            id: string;
            /**
             * @description 体育项目URN
             * @example sr:sport:1
             */
            name: string;
            /**
             * @description 体育项目名称
             * @example Football
             */
            nameZh: string;
            /**
             * Format: int64
             * @description 匹配的比赛数量
             * @example 5
             */
            matchCount: number;
            /**
             * @description 国家ID
             * @example 1
             */
            countryId: string;
            /**
             * @description 国家名称
             * @example England
             */
            country: string;
            /**
             * @description 国家图标
             * @example https://cdn.sportradar.com/images/sport/countries/32/en/1.png
             */
            countryUrl: string;
            /**
             * @description 联赛ID
             * @example 1
             */
            leagueId: string;
            /**
             * @description 联赛名称
             * @example Premier League
             */
            league: string;
            /**
             * @description 联赛图标
             * @example https://cdn.sportradar.com/images/sport/leagues/32/en/1.png
             */
            leagueLogoUrl: string;
        };
        /** @description dps推荐返回结构 */
        DpsResultListVaixHotMatchesResponse: {
            /** @description 是否成功 */
            success: boolean;
            /** @description 错误码 */
            errCode: string;
            /** @description 错误信息 */
            errMessage: string;
            /** @description 请求ID */
            requestId: string;
            /** @description 国家 */
            country: string;
            data: components["schemas"]["VaixHotMatchesResponse"][];
            /**
             * @description 最大数量
             * @example 10
             */
            max_num: string;
        };
        /** @description 从盘口服务获取的市场批量响应数据 */
        MarketBatchResponse: {
            marketList: components["schemas"]["MarketResponse"][];
            /** Format: int32 */
            totalMarkets: number;
            hasOtherBalance: boolean;
        };
        /** @description 赛季比赛文档DTO，包含赛季信息和比赛详细数据 */
        SeasonMatchDocumentInnerDto: {
            /**
             * @description 赛季ID
             * @example sr:season:93931
             */
            seasonId: string;
            /**
             * @description 分数
             * @example 1
             */
            score: string;
            /**
             * @description 赛季名称
             * @example Premier League 22/23
             */
            seasonName: string;
            /**
             * @description 赛季年份
             * @example 22/23
             */
            seasonYear: string;
            /**
             * @description 比赛ID或URN
             * @example sr:match:37939735
             */
            id: string;
            /**
             * @description 比赛名称
             * @example Arsenal vs Manchester United
             */
            name: string;
            /**
             * @description 主队ID
             * @example sr:competitor:42
             */
            homeId: string;
            /**
             * @description 主队名称
             * @example Arsenal
             */
            homeName: string;
            /**
             * @description 主队简称
             * @example ARS
             */
            homeShortName: string;
            /**
             * @description 主队Logo URL
             * @example https://example.com/arsenal_logo.png
             */
            homeLogoUrl: string;
            /** @description 主队球衣 */
            homeJersey: string;
            /**
             * @description 主队国家/地区代码
             * @example ENG
             */
            homeCountryCode: string;
            /**
             * @description 客队ID
             * @example sr:competitor:35
             */
            awayId: string;
            /**
             * @description 客队名称
             * @example Manchester United
             */
            awayName: string;
            /**
             * @description 客队简称
             * @example MU
             */
            awayShortName: string;
            /**
             * @description 客队Logo URL
             * @example https://example.com/mu_logo.png
             */
            awayLogoUrl: string;
            /** @description 客队球衣 */
            awayJersey: string;
            /**
             * @description 客队国家/地区代码
             * @example ENG
             */
            awayCountryCode: string;
            /**
             * @description 场馆ID
             * @example sr:venue:123
             */
            venueId: string;
            /**
             * @description 场馆名称
             * @example Emirates Stadium
             */
            venueName: string;
            /**
             * @description 裁判ID
             * @example sr:referee:456
             */
            refereeId: string;
            /**
             * @description 裁判名称
             * @example Anthony Taylor
             */
            refereeName: string;
            /**
             * @description 比赛类型
             * @example match
             */
            type: string;
            /**
             * @description 分组ID
             * @example sr:group:789
             */
            groupId: string;
            /**
             * @description 分组名称
             * @example Group A
             */
            groupName: string;
            /**
             * @description 阶段（例如：小组赛、淘汰赛）
             * @example Group Stage
             */
            phase: string;
            /**
             * @description 其他比赛ID
             * @example sr:match:99999
             */
            otherMatchId: string;
            /**
             * @description 联赛轮次
             * @example 21
             */
            tournamentRound: string;
            /**
             * Format: int64
             * @description 计划开始时间（Unix时间戳，毫秒）
             * @example 1674408600000
             */
            scheduledTime: number;
            /**
             * Format: int64
             * @description 计划结束时间（Unix时间戳，毫秒）
             * @example 1674415800000
             */
            scheduledEndTime: number;
            /**
             * Format: int32
             * @description 比赛状态
             */
            status: number;
            /** @description 比赛状态名称 */
            statusName: string;
            /**
             * Format: int32
             * @description 比赛状态
             */
            matchStatus: number;
            /** @description 比赛状态名称 */
            matchStatusName: string;
            sportEventStatus: components["schemas"]["SportEventStatusDto"];
            /**
             * @description 是否有雷达滚球赔率
             * @example true
             */
            hasRadarLiveOdds: boolean;
            /**
             * @description 是否有雷达赛前盘赔率
             * @example true
             */
            hasRadarPreMatchOdds: boolean;
            marketBatchResponse: components["schemas"]["MarketBatchResponse"];
        };
        /** @description 体育ES数据 */
        VaixHotMatchesResponse: {
            /**
             * @description 聚合ID
             * @example sr:tournament:12345
             */
            id: string;
            /**
             * @description 锦标赛的名称
             * @example Premier League
             */
            name: string;
            /**
             * @description 锦标赛的中文名称
             * @example 英超联赛
             */
            nameZh: string;
            /**
             * @description 锦标赛的简称
             * @example 英超
             */
            shortName: string;
            /**
             * @description 锦标赛的logo URL
             * @example https://example.com/tournament_logo.png
             */
            logoUrl: string;
            /**
             * Format: int32
             * @description 联赛等级, -1：未初始化
             * @example 1
             */
            level: number;
            /**
             * Format: int32
             * @description 性别：0男，1女，2未知
             * @example 0
             */
            gender: number;
            /**
             * @description 关联的锦标赛当前赛季ID
             * @example sr:season:93931
             */
            currentSeasonId: string;
            /**
             * Format: int32
             * @description 联赛类型：-1 未初始化, 0-未知、1-联赛、2-杯赛、3-友谊赛
             * @example 1
             */
            type: number;
            /**
             * Format: int32
             * @description 排序值
             * @example 10
             */
            sort: number;
            /**
             * @description 是否国家队比赛
             * @example true
             */
            isCountry: boolean;
            /**
             * @description 关联的项目类别ID
             * @example sr:category:29
             */
            categoryId: string;
            /**
             * @description 关联的项目类别名称
             * @example England
             */
            categoryName: string;
            /**
             * @description 关联的项目类别中文名称
             * @example 英格兰
             */
            categoryNameZh: string;
            /**
             * @description 关联的项目类别Logo URL
             * @example https://example.com/category_logo.png
             */
            categoryLogoUrl: string;
            /**
             * @description 关联的项目类别国家/地区代码
             * @example ENG
             */
            categoryCountryCode: string;
            /**
             * @description 关联的体育项目ID
             * @example sr:sport:1
             */
            sportId: string;
            /**
             * @description 体育项目名称
             * @example Football
             */
            sportName: string;
            /**
             * @description 体育项目中文名称
             * @example 足球
             */
            sportNameZh: string;
            /**
             * @description 体育项目Logo URL
             * @example https://example.com/sport_logo.png
             */
            sportLogoUrl: string;
            /**
             * Format: int64
             * @description 关联的比赛数量
             * @example 10
             */
            matchCount: number;
            /** @description 关联的比赛列表 */
            matches: components["schemas"]["SeasonMatchDocumentInnerDto"][];
        };
        /** @description dps推荐返回结构 */
        DpsResultListVaixBetSlipsResponse: {
            /** @description 是否成功 */
            success: boolean;
            /** @description 错误码 */
            errCode: string;
            /** @description 错误信息 */
            errMessage: string;
            /** @description 请求ID */
            requestId: string;
            /** @description 国家 */
            country: string;
            data: components["schemas"]["VaixBetSlipsResponse"][];
            /**
             * @description 最大数量
             * @example 10
             */
            max_num: string;
        };
        /** @description 构建信息(只有betting接口才会有) */
        VaixBetBuildersResponse: {
            /** @description 市场类型 */
            marketType: string;
            /** @description 市场 */
            market: string;
            /**
             * Format: double
             * @description 赔率
             */
            quote: number;
            /** @description 市场类型id */
            marketTypeId: string;
            /** @description 赔率编码 */
            code: string;
            /** @description 结果 */
            outcome: string;
            /** @description 结果id */
            outcomeId: string;
            /** @description 赔率区间 */
            quoteGroup: string;
            /** @description selectionId */
            selectionId: string;
            /**
             * Format: int32
             * @description 投注数量
             */
            count: number;
        };
        /** @description 比赛信息 */
        VaixBetItemResponse: {
            /** @description 运动id */
            sportId: string;
            /** @description 运动类型 */
            sport: string;
            /** @description 国家id */
            countryId: string;
            /** @description 国家 */
            country: string;
            /** @description 国家图片 */
            countryLogoUrl: string;
            /** @description 联赛id */
            leagueId: string;
            /** @description 联赛 */
            league: string;
            /** @description 联赛图片 */
            leagueLogoUrl: string;
            /**
             * Format: int32
             * @description 投注数量
             */
            count: number;
            /** @description 状态 */
            status: string;
            /** @description 开始时间 */
            begin: string;
            /**
             * Format: int64
             * @description 计划开始时间（Unix时间戳，毫秒）
             * @example 1674408600000
             */
            scheduledTime: number;
            /**
             * Format: double
             * @description 赔率
             */
            quote: number;
            /** @description 比赛 id */
            eventId: string;
            /** @description 队伍信息 */
            participants: string[];
            /** @description 队伍id */
            participantIds: string[];
            /** @description selectionId */
            selectionId: string;
            /**
             * @description 是否为国家比赛
             * @example true
             */
            isCountry: boolean;
            /**
             * @description 主队ID
             * @example sr:competitor:42
             */
            homeId: string;
            /**
             * @description 主队名称
             * @example Arsenal
             */
            homeName: string;
            /**
             * @description 主队简称
             * @example ARS
             */
            homeShortName: string;
            /**
             * @description 主队Logo URL
             * @example https://example.com/arsenal_logo.png
             */
            homeLogoUrl: string;
            /** @description 主队球衣 */
            homeJersey: string;
            /**
             * @description 主队国家代码
             * @example ENG
             */
            homeCountryCode: string;
            /**
             * @description 客队ID
             * @example sr:competitor:35
             */
            awayId: string;
            /**
             * @description 客队名称
             * @example Manchester United
             */
            awayName: string;
            /**
             * @description 客队简称
             * @example MU
             */
            awayShortName: string;
            /**
             * @description 客队Logo URL
             * @example https://example.com/mu_logo.png
             */
            awayLogoUrl: string;
            /** @description 客队球衣 */
            awayJersey: string;
            /**
             * @description 客队国家代码
             * @example ENG
             */
            awayCountryCode: string;
            /** @description 市场 */
            market: string;
            /** @description 市场id */
            marketId: Record<string, never>;
            /** @description 市场类型 */
            marketType: string;
            /** @description 市场类型id */
            marketTypeId: string;
            /** @description 赔率编码 */
            code: string;
            /** @description 结果 */
            outcome: string;
            /** @description 结果id */
            outcomeId: string;
            /** @description 赔率区间 */
            quoteGroup: string;
            /** @description 构建信息(只有betting接口才会有) */
            vaixBetBuildersResponseList: components["schemas"]["VaixBetBuildersResponse"][];
        };
        VaixBetSlipsResponse: {
            /** @description 类型,1:同运动，同联赛，不同比赛;2:同运动，不同联赛，不同比赛;3:同运动,同比赛(只有betting接口才会有) */
            type: string;
            /** @description 类型id,针对type=3的时,所对应的标识 */
            typeId: string;
            /** @description 运动id */
            sportId: string;
            /** @description 运动类型 */
            sport: string;
            /** @description 国家 */
            country: string;
            /** @description 国家id */
            countryId: string;
            /** @description 国家图片 */
            countryLogoUrl: string;
            /** @description 联赛 */
            league: string;
            /** @description 联赛id */
            leagueId: string;
            /** @description 联赛图片 */
            leagueLogoUrl: string;
            /**
             * Format: double
             * @description 赔率
             */
            quote: number;
            /** @description 比赛信息 */
            vaixBetItemResponseList: components["schemas"]["VaixBetItemResponse"][];
        };
        /** @description dps推荐返回结构 */
        DpsResultListSportSearchResponse: {
            /** @description 是否成功 */
            success: boolean;
            /** @description 错误码 */
            errCode: string;
            /** @description 错误信息 */
            errMessage: string;
            /** @description 请求ID */
            requestId: string;
            /** @description 国家 */
            country: string;
            data: components["schemas"]["SportSearchResponse"][];
            /**
             * @description 最大数量
             * @example 10
             */
            max_num: string;
        };
        SportSearchResponse: {
            /** @description 运动类型ID */
            sportId: string;
            /** @description 运动类型名称 */
            sportName: string;
            /** @description 运动类型名称图片地址 */
            sportLogoUrl: string;
            /**
             * Format: int64
             * @description 比赛数量
             */
            matchesCount: number;
            /** @description 比赛列表 */
            leagueList: components["schemas"]["VaixHotMatchesResponse"][];
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    checkServer: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["Health"];
                };
            };
        };
    };
    checkServer_1: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["Health"];
                };
            };
        };
    };
    getBatchItemLocalRecommendation_2: {
        parameters: {
            query?: never;
            header?: {
                "x-client-type"?: string;
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchItemRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsGameResultListListRecommendItemData"];
                };
            };
        };
    };
    getBatchItemLocalRecommendation_1: {
        parameters: {
            query?: never;
            header?: {
                "x-client-type"?: string;
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchItemRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsGameResultListListRecommendItemData"];
                };
            };
        };
    };
    getTagProviderRecommend: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["TagProviderRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleRecommandResponse"];
                };
            };
        };
    };
    getRelevantRecommend: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RelevantRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleRecommandResponse"];
                };
            };
        };
    };
    getProviderRecommend: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ProviderRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleRecommandResponse"];
                };
            };
        };
    };
    getPersonalRecommend: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PersonalRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleRecommandResponse"];
                };
            };
        };
    };
    getOrderedProviderRecommend: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["OrderedProviderRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleRecommandResponse"];
                };
            };
        };
    };
    getOrderedItemsRecommend: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["OrderedItemsRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleRecommandResponse"];
                };
            };
        };
    };
    getNewGameRecommend: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["NewGameRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleRecommandResponse"];
                };
            };
        };
    };
    getLotteryPersonalRecommend: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["LotteryPersonalRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleRecommandResponse"];
                };
            };
        };
    };
    getHotProviderRecommend: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["HotProviderRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleRecommandResponse"];
                };
            };
        };
    };
    getExploreRecommend: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ExploreRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleRecommandResponse"];
                };
            };
        };
    };
    getCryptoRecommend: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CryptoRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleRecommandResponse"];
                };
            };
        };
    };
    getCasinoRecommend: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CasinoRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultipleBaseRecommandResponse"];
                };
            };
        };
    };
    getTagRecommendation: {
        parameters: {
            query?: never;
            header?: {
                "x-client-type"?: string;
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["TagRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsGameResultListRecommendItemData"];
                };
            };
        };
    };
    getTagRecommendation_1: {
        parameters: {
            query?: never;
            header?: {
                "x-client-type"?: string;
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["TagRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsGameResultListRecommendItemData"];
                };
            };
        };
    };
    getSearchItemRecommendation: {
        parameters: {
            query?: never;
            header?: {
                "x-client-type"?: string;
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SearchRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsGameResultListRecommendItemData"];
                };
            };
        };
    };
    getSearchItemRecommendation_1: {
        parameters: {
            query?: never;
            header?: {
                "x-client-type"?: string;
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SearchRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsGameResultListRecommendItemData"];
                };
            };
        };
    };
    getRelevantGameRecommendation: {
        parameters: {
            query?: never;
            header?: {
                "x-client-type"?: string;
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RelevantGameRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsGameResultListRecommendItemData"];
                };
            };
        };
    };
    getRelevantGameRecommendation_1: {
        parameters: {
            query?: never;
            header?: {
                "x-client-type"?: string;
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RelevantGameRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsGameResultListRecommendItemData"];
                };
            };
        };
    };
    getProviderRecommendation: {
        parameters: {
            query?: never;
            header?: {
                "x-client-type"?: string;
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ProviderRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsGameResultListRecommendItemData"];
                };
            };
        };
    };
    getProviderRecommendation_1: {
        parameters: {
            query?: never;
            header?: {
                "x-client-type"?: string;
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ProviderRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsGameResultListRecommendItemData"];
                };
            };
        };
    };
    getNewGamesRecommendation: {
        parameters: {
            query?: never;
            header?: {
                "x-client-type"?: string;
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["NewGamesRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsGameResultListRecommendItemData"];
                };
            };
        };
    };
    getNewGamesRecommendation_1: {
        parameters: {
            query?: never;
            header?: {
                "x-client-type"?: string;
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["NewGamesRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsGameResultListRecommendItemData"];
                };
            };
        };
    };
    getItemRecommendation: {
        parameters: {
            query?: never;
            header?: {
                "x-client-type"?: string;
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ItemRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsGameResultListRecommendItemData"];
                };
            };
        };
    };
    getItemRecommendation_1: {
        parameters: {
            query?: never;
            header?: {
                "x-client-type"?: string;
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ItemRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsGameResultListRecommendItemData"];
                };
            };
        };
    };
    getContinueGameRecommendation: {
        parameters: {
            query?: never;
            header?: {
                "x-client-type"?: string;
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ItemRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsGameResultListRecommendItemData"];
                };
            };
        };
    };
    getContinueGameRecommendation_1: {
        parameters: {
            query?: never;
            header?: {
                "x-client-type"?: string;
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ItemRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsGameResultListRecommendItemData"];
                };
            };
        };
    };
    getBatchItemRecommendation: {
        parameters: {
            query?: never;
            header?: {
                "x-client-type"?: string;
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchItemRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsGameResultListListRecommendItemData"];
                };
            };
        };
    };
    getRedis: {
        parameters: {
            query: {
                redisKey: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": Record<string, never>;
                };
            };
        };
    };
    deleteRedis: {
        parameters: {
            query: {
                redisKey: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": Record<string, never>;
                };
            };
        };
    };
    uploadCsv: {
        parameters: {
            query?: {
                gameHotsEnums?: "FIRST_HOTS" | "SECOND_HOTS" | "ALGO";
                sence?: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": {
                    /** Format: binary */
                    file: string;
                };
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": Record<string, never>;
                };
            };
        };
    };
    getItemRecommendation_2: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RelevantGameRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsGameResultListRecommendItemData"];
                };
            };
        };
    };
    getGameCache: {
        parameters: {
            query?: never;
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RelevantGameRecommandRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": string;
                };
            };
        };
    };
    getSecond: {
        parameters: {
            query?: {
                /**
                 * @description 用户ID
                 * @example default
                 */
                distinct_id?: string;
                /**
                 * @description 总条数范围1-1000
                 * @example 100
                 */
                limit?: number;
                /**
                 * @description log_id
                 * @example 11211111121
                 */
                log_id?: string;
            };
            header?: {
                "X-Country"?: string;
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsGameResultListDpsMatchResponse"];
                };
            };
        };
    };
    getTopMatches: {
        parameters: {
            query?: {
                /**
                 * @description 用户ID
                 * @example default
                 */
                distinctId?: string;
                /**
                 * @description 国家代码
                 * @example default
                 */
                country?: string;
                /**
                 * @description 推荐数量，范围1-100
                 * @example 10
                 */
                pageSize?: number;
                /**
                 * @description 请求logId
                 * @example 112121
                 */
                logId?: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsResultListVaixTopMatchesResponse"];
                };
            };
        };
    };
    getSports: {
        parameters: {
            query?: {
                /**
                 * @description 用户ID
                 * @example default
                 */
                distinctId?: string;
                /**
                 * @description 国家代码
                 * @example default
                 */
                country?: string;
                /**
                 * @description 推荐数量，范围1-100
                 * @example 10
                 */
                pageSize?: number;
                /**
                 * @description 请求logId
                 * @example 112121
                 */
                logId?: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsResultListVaixSportsResponse"];
                };
            };
        };
    };
    getHotMatches: {
        parameters: {
            query: {
                /**
                 * @description 用户ID
                 * @example default
                 */
                distinctId?: string;
                /**
                 * @description 国家代码
                 * @example default
                 */
                country?: string;
                /**
                 * @description 运动类型
                 * @example sr:sport:1
                 */
                sportId: string;
                /**
                 * @description 推荐数量，范围1-100
                 * @example 10
                 */
                pageSize?: number;
                /**
                 * @description 请求logId
                 * @example 112121
                 */
                logId?: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsResultListVaixHotMatchesResponse"];
                };
            };
        };
    };
    getHotCombosMatches: {
        parameters: {
            query?: {
                /**
                 * @description 用户ID
                 * @example default
                 */
                distinctId?: string;
                /**
                 * @description 国家代码
                 * @example default
                 */
                country?: string;
                /**
                 * @description 推荐数量，范围1-100
                 * @example 10
                 */
                pageSize?: number;
                /**
                 * @description 请求logId
                 * @example 112121
                 */
                logId?: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsResultListVaixBetSlipsResponse"];
                };
            };
        };
    };
    getCustomBetMatches: {
        parameters: {
            query: {
                /**
                 * @description 用户ID
                 * @example default
                 */
                distinctId?: string;
                /**
                 * @description 国家代码
                 * @example default
                 */
                country?: string;
                /**
                 * @description typeIdList
                 * @example 1111
                 */
                typeIdList: string[];
                /**
                 * @description 推荐数量，范围1-20
                 * @example 20
                 */
                pageSize?: number;
                /**
                 * @description 请求logId
                 * @example 112121
                 */
                logId?: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsResultListVaixBetSlipsResponse"];
                };
            };
        };
    };
    getBettingMatches: {
        parameters: {
            query?: {
                /**
                 * @description 用户ID
                 * @example default
                 */
                distinctId?: string;
                /**
                 * @description 国家代码
                 * @example default
                 */
                country?: string;
                /**
                 * @description 推荐数量，范围1-20
                 * @example 20
                 */
                pageSize?: number;
                /**
                 * @description 请求logId
                 * @example 112121
                 */
                logId?: string;
            };
            header?: {
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsResultListVaixBetSlipsResponse"];
                };
            };
        };
    };
    getRecommandSportSearch: {
        parameters: {
            query: {
                /**
                 * @description 用户ID
                 * @example default
                 */
                distinct_id?: string;
                /**
                 * @description 总条数范围1-1000
                 * @example 100
                 */
                limit?: number;
                /**
                 * @description keyWord
                 * @example keyWord
                 */
                keyWord: string;
                /**
                 * @description log_id
                 * @example 11211111121
                 */
                log_id?: string;
            };
            header?: {
                "X-Country"?: string;
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsResultListSportSearchResponse"];
                };
            };
        };
    };
    getSportSearchSport: {
        parameters: {
            query?: {
                /**
                 * @description 用户ID
                 * @example default
                 */
                distinct_id?: string;
                /**
                 * @description 总条数范围1-1000
                 * @example 100
                 */
                limit?: number;
                /**
                 * @description log_id
                 * @example 11211111121
                 */
                log_id?: string;
            };
            header?: {
                "X-Country"?: string;
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsResultListVaixSportsResponse"];
                };
            };
        };
    };
    getSportSearchLeague: {
        parameters: {
            query?: {
                /**
                 * @description 用户ID
                 * @example default
                 */
                distinct_id?: string;
                /**
                 * @description 总条数范围1-1000
                 * @example 100
                 */
                limit?: number;
                /**
                 * @description log_id
                 * @example 11211111121
                 */
                log_id?: string;
            };
            header?: {
                "X-Country"?: string;
                /**
                 * @description 客户端类型 /api 开头的所有接口gateway都会限制
                 *     规则如下：[xx业务]-[xx端]
                 *     BZ业务：
                 *     1.网页端 BZ-WEB
                 *     2.app端 BZ-APP
                 *     3.小程序端 BZ-AAPLET
                 *     dev、test环境在swagger上可以使用默认值：SWAGGER
                 */
                "X-Client-Type"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DpsResultListVaixSportsResponse"];
                };
            };
        };
    };
}
export enum ApiPaths {
    checkServer = "/checkServer",
    checkServer_1 = "/checkServer",
    getBatchItemLocalRecommendation_2 = "/api/recommand/v2/dps/batch_item",
    getBatchItemLocalRecommendation_1 = "/openapi/recommand/v2/batch_item_local",
    getTagProviderRecommend = "/openapi/recommand/rec/tag_provider",
    getRelevantRecommend = "/openapi/recommand/rec/relevant",
    getProviderRecommend = "/openapi/recommand/rec/provider",
    getPersonalRecommend = "/openapi/recommand/rec/personal",
    getOrderedProviderRecommend = "/openapi/recommand/rec/ordered_provider",
    getOrderedItemsRecommend = "/openapi/recommand/rec/ordered_items",
    getNewGameRecommend = "/openapi/recommand/rec/new_game",
    getLotteryPersonalRecommend = "/openapi/recommand/rec/lottery_personal",
    getHotProviderRecommend = "/openapi/recommand/rec/hot_provider",
    getExploreRecommend = "/openapi/recommand/rec/explore",
    getCryptoRecommend = "/openapi/recommand/rec/crypto",
    getCasinoRecommend = "/openapi/recommand/rec/casino",
    getTagRecommendation = "/api/recommand/v2/dps/tag",
    getTagRecommendation_1 = "/openapi/recommand/v2/tag",
    getSearchItemRecommendation = "/api/recommand/v2/dps/search",
    getSearchItemRecommendation_1 = "/openapi/recommand/v2/search",
    getRelevantGameRecommendation = "/openapi/recommand/v2/relevant_game",
    getRelevantGameRecommendation_1 = "/api/recommand/v2/dps/relevant_game",
    getProviderRecommendation = "/openapi/recommand/v2/provider",
    getProviderRecommendation_1 = "/api/recommand/v2/dps/provider",
    getNewGamesRecommendation = "/openapi/recommand/v2/new_games",
    getNewGamesRecommendation_1 = "/api/recommand/v2/dps/new_games",
    getItemRecommendation = "/openapi/recommand/v2/item",
    getItemRecommendation_1 = "/api/recommand/v2/dps/item",
    getContinueGameRecommendation = "/openapi/recommand/v2/continue_game",
    getContinueGameRecommendation_1 = "/api/recommand/v2/dps/continue_game",
    getBatchItemRecommendation = "/openapi/recommand/v2/batch_item",
    getRedis = "/api/recommand/dps/util/getRedis",
    deleteRedis = "/api/recommand/dps/util/deleteRedis",
    uploadCsv = "/api/recommand/dps/util/csvUpload",
    getItemRecommendation_2 = "/api/recommand/dps/game/recommend",
    getGameCache = "/api/recommand/dps/game/cache/recommend",
    getSecond = "/api/recommand/sportData/sport/recommend",
    getTopMatches = "/api/recommand/sport/vaix/topMatches",
    getSports = "/api/recommand/sport/vaix/sports",
    getHotMatches = "/api/recommand/sport/vaix/hotMatches",
    getHotCombosMatches = "/api/recommand/sport/vaix/hotCombosMatches",
    getCustomBetMatches = "/api/recommand/sport/vaix/customBetMatches",
    getBettingMatches = "/api/recommand/sport/vaix/bettingMatches",
    getRecommandSportSearch = "/api/sport/recommand/sport/v2/search",
    getSportSearchSport = "/api/sport/recommand/sport/v2/search/sport",
    getSportSearchLeague = "/api/sport/recommand/sport/v2/search/league"
}
